// Kakao Maps SDK dynamic loader — singleton promise prevents duplicate loading.
// SDK requires autoload=false; resolve is called inside kakao.maps.load() callback.

let loadPromise: Promise<void> | null = null;

export function loadKakaoMap(): Promise<void> {
  if (loadPromise) return loadPromise;

  loadPromise = new Promise<void>((resolve, reject) => {
    if (typeof window === 'undefined') {
      reject(new Error('loadKakaoMap requires a browser environment'));
      return;
    }

    // Already loaded by a previous session
    if (window.kakao?.maps) {
      window.kakao.maps.load(() => resolve());
      return;
    }

    const appKey = import.meta.env.VITE_KAKAO_JS_KEY as string | undefined;
    if (!appKey) {
      reject(new Error('VITE_KAKAO_JS_KEY is not set'));
      return;
    }

    const script = document.createElement('script');
    script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=${appKey}&autoload=false&libraries=services`;
    script.async = true;

    script.onload = () => {
      window.kakao.maps.load(() => resolve());
    };
    script.onerror = () => {
      loadPromise = null; // allow retry on failure
      reject(new Error('Failed to load Kakao Maps SDK'));
    };

    document.head.appendChild(script);
  });

  return loadPromise;
}
